import React, { useState } from "react";
import { useAuth } from "./AuthContext";

const inp = { width: "100%", border: "1px solid #d1d5db", borderRadius: 8, padding: "10px 14px", fontSize: 14, fontFamily: "inherit", outline: "none" };
const btn = (c) => ({ width: "100%", padding: 11, borderRadius: 8, border: c === "white" ? "1px solid #d1d5db" : "none", cursor: "pointer", fontWeight: 700, fontSize: 14, background: c === "blue" ? "#1d4ed8" : c === "white" ? "white" : "#16a34a", color: c === "white" ? "#374151" : "white", display: "flex", alignItems: "center", justifyContent: "center", gap: 10 });
const lnk = { color: "#1d4ed8", cursor: "pointer", fontSize: 13, textDecoration: "underline" };

export default function LoginPage() {
  const { loginEmail, signupEmail, loginGoogle, resetPassword } = useAuth();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    setError(""); setMsg("");
    if (!email) return setError("Enter your email");
    if (mode === "reset") {
      setLoading(true);
      try { await resetPassword(email); setMsg("Reset email sent. Check your inbox."); }
      catch (e) { setError(e.message); }
      setLoading(false); return;
    }
    if (!password) return setError("Enter your password");
    if (mode === "signup" && password !== confirm) return setError("Passwords do not match");
    if (password.length < 6) return setError("Password must be at least 6 characters");
    setLoading(true);
    try {
      if (mode === "login") await loginEmail(email, password);
      else await signupEmail(email, password);
    } catch (e) {
      if (e.code === "auth/user-not-found") setError("No account found. Sign up first.");
      else if (e.code === "auth/wrong-password") setError("Wrong password.");
      else if (e.code === "auth/email-already-in-use") setError("Email already registered. Log in instead.");
      else setError(e.message);
    }
    setLoading(false);
  }

  async function handleGoogle() {
    setError(""); setLoading(true);
    try { await loginGoogle(); } catch (e) { setError(e.message); }
    setLoading(false);
  }

  return (
    <div style={{ minHeight: "100vh", background: "#f9fafb", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Inter', -apple-system, sans-serif", padding: 16 }}>
      <div style={{ background: "white", borderRadius: 12, border: "1px solid #e5e7eb", padding: 36, width: "100%", maxWidth: 380, boxShadow: "0 4px 24px rgba(0,0,0,0.06)" }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ fontWeight: 800, fontSize: 20, color: "#111827" }}>Champion Trader</div>
          <div style={{ fontSize: 13, color: "#6b7280", marginTop: 4 }}>
            {mode === "login" ? "Sign in to your journal" : mode === "signup" ? "Create your journal account" : "Reset your password"}
          </div>
        </div>

        {mode !== "reset" && (
          <>
            <button style={btn("white")} onClick={handleGoogle} disabled={loading}>
              <svg width="18" height="18" viewBox="0 0 18 18">
                <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 002.38-5.88c0-.57-.05-.66-.15-1.18z"/>
                <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 01-7.18-2.54H1.83v2.07A8 8 0 008.98 17z"/>
                <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 010-3.04V5.41H1.83a8 8 0 000 7.18l2.67-2.07z"/>
                <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 001.83 5.4L4.5 7.49a4.77 4.77 0 014.48-3.31z"/>
              </svg>
              Continue with Google
            </button>
            <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "20px 0" }}>
              <div style={{ flex: 1, height: 1, background: "#e5e7eb" }} />
              <span style={{ fontSize: 12, color: "#9ca3af" }}>or</span>
              <div style={{ flex: 1, height: 1, background: "#e5e7eb" }} />
            </div>
          </>
        )}

        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", display: "block", marginBottom: 5 }}>Email</label>
          <input type="email" style={inp} placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && handleSubmit()} />
        </div>

        {mode !== "reset" && (
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", display: "block", marginBottom: 5 }}>Password</label>
            <input type="password" style={inp} placeholder="Min 6 characters" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === "Enter" && handleSubmit()} />
          </div>
        )}

        {mode === "signup" && (
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", display: "block", marginBottom: 5 }}>Confirm Password</label>
            <input type="password" style={inp} placeholder="Repeat password" value={confirm} onChange={e => setConfirm(e.target.value)} onKeyDown={e => e.key === "Enter" && handleSubmit()} />
          </div>
        )}

        {error && <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 6, padding: "8px 12px", fontSize: 13, color: "#dc2626", marginBottom: 12 }}>{error}</div>}
        {msg && <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 6, padding: "8px 12px", fontSize: 13, color: "#15803d", marginBottom: 12 }}>{msg}</div>}

        <button style={btn("blue")} onClick={handleSubmit} disabled={loading}>
          {loading ? "Please wait..." : mode === "login" ? "Sign In" : mode === "signup" ? "Create Account" : "Send Reset Email"}
        </button>

        <div style={{ marginTop: 20, textAlign: "center", display: "flex", flexDirection: "column", gap: 8 }}>
          {mode === "login" && (<>
            <span style={{ fontSize: 13, color: "#6b7280" }}>No account? <span style={lnk} onClick={() => { setMode("signup"); setError(""); }}>Sign up free</span></span>
            <span style={lnk} onClick={() => { setMode("reset"); setError(""); }}>Forgot password?</span>
          </>)}
          {mode === "signup" && <span style={{ fontSize: 13, color: "#6b7280" }}>Already have an account? <span style={lnk} onClick={() => { setMode("login"); setError(""); }}>Sign in</span></span>}
          {mode === "reset" && <span style={lnk} onClick={() => { setMode("login"); setError(""); }}>Back to sign in</span>}
        </div>
        <div style={{ marginTop: 20, fontSize: 11, color: "#9ca3af", textAlign: "center" }}>Your journal data is private and syncs across all your devices.</div>
      </div>
    </div>
  );
}
